import { MoreVert } from "@mui/icons-material"
import { Menu, MenuItem } from "@mui/material"
import React, { FC, useMemo, useState } from "react"

type Props = {
  onViewUser: () => void
  onDeleteUser: () => void
}

const UserTableAction: FC<Props> = ({ onViewUser, onDeleteUser }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const open = useMemo(() => Boolean(anchorEl), [anchorEl])
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        className="text-xl"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreVert />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          className: "bg-kyzzen-primary border border-kyzzen-secondary",
        }}
        MenuListProps={{
          sx: {
            py: 0,
            "& .MuiMenuItem-root": {
              color: "#fff",
              fontSize: 14,
              fontFamily: '"hero-new", san-serif',
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleClose()
            onViewUser()
          }}
        >
          View Profile
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose()
            onDeleteUser()
          }}
          color="error"
        >
          Delete
        </MenuItem>
      </Menu>
    </>
  )
}

export default UserTableAction
